import {
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { useState } from "react";
import { boxSx, deleteAccount } from "./utils";
import { useSignout } from "../../../../../components/user/BCPAuthReducers";
import ModalLoadingFull from "../../../../../components/modals/ModalLoadingFull";
import { isBrand } from "../../../../../global/environmentVariables";

const IS_GW = isBrand("gw");

const DeleteAccount = ({ navigate, userId, t }) => {
  const signoutReducer = useSignout();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const onPasswordChange = (e) => {
    const {
      target: { value }
    } = e;

    if (!isTouched) setIsTouched(true);
    setPassword(value);
    setIsPasswordError(!value.length);
  };

  const onClose = () => {
    setPassword("");
    setIsTouched(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Grid item xs={12} sx={{ mt: 8 }}>
        <Divider />
      </Grid>
      <Grid item xs={12} textAlign="right">
        <Button
          variant="outlined"
          color={IS_GW ? "error" : "neutral"}
          onClick={setIsModalOpen.bind(this, true)}
        >
          {t("deleteAccount", {
            defaultValue: "Delete Account",
            keyPrefix: "buttons"
          })}
        </Button>
      </Grid>
      <Modal
        open={isModalOpen}
        onClose={onClose}
        aria-labelledby="delete-account-title"
        aria-describedby="delete-account-description"
        BackdropProps={{ timeout: 500 }}
      >
        <Box sx={boxSx}>
          <Typography
            id="delete-account-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            {t("deleteAccount.header", {
              defaultValue: "What happens if I permanently delete my account?"
            })}
          </Typography>

          <Typography paragraph>
            {t("deleteAccount.p1", {
              defaultValue:
                "You will no longer be able to login with this email/username."
            })}
          </Typography>

          <Typography paragraph>
            {t("deleteAccount.p2", {
              defaultValue:
                "Personal identifying information will be removed (e.g., first name, last name, and email will be removed). You will be disconnected from your event history."
            })}
          </Typography>
          <Typography
            paragraph
            variant="h6"
            component="h2"
            sx={{
              textTransform: "uppercase",
              color: "error.main"
            }}
          >
            {t("deleteAccount.p3", {
              defaultValue: "This process cannot be reversed!"
            })}
          </Typography>
          <Typography paragraph>
            {t("deleteAccount.p3b", {
              defaultValue:
                "If you have questions about accounts, and would like advice before selecting Delete as an option, please contact support@bestcoastpairings.com"
            })}
          </Typography>
          <Typography id="delete-account-description">
            {t("deleteAccount.p4", {
              defaultValue:
                "If you wish to continue, please type your password to confirm this decision."
            })}
          </Typography>
          <Grid container spacing={1} sx={{ marginTop: "1rem" }}>
            <Grid item xs={12}>
              <TextField
                error={isTouched && isPasswordError}
                helperText={isTouched && "Required"}
                name="password"
                value={password}
                type="password"
                label={t("password", {
                  defaultValue: "Password",
                  keyPrefix: "fields"
                })}
                variant="outlined"
                inputProps={{ maxLength: 255 }}
                required
                fullWidth
                onBlur={onPasswordChange}
                onChange={onPasswordChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                onClick={onClose}
                fullWidth
                color="info"
                variant="outlined"
                disabled={isProcessing}
              >
                {t("cancel", {
                  defaultValue: "Cancel",
                  keyPrefix: "buttons"
                })}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button
                onClick={deleteAccount.bind(
                  this,
                  setIsProcessing,
                  setIsModalOpen,
                  password,
                  signoutReducer,
                  navigate,
                  userId
                )}
                fullWidth
                color="error"
                variant="contained"
                disabled={isProcessing || isPasswordError || password === ""}
              >
                {t("delete", {
                  defaultValue: "Delete",
                  keyPrefix: "buttons"
                })}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {isProcessing && <ModalLoadingFull />}
    </>
  );
};

export default DeleteAccount;
